import React, { useState, useEffect } from "react";
import Header from '../components/Header'
import Footer from '../components/Footer'
import usePageSEO from '../hooks/usePageSEO'
import axios from "axios";
import Loader from '../components/Loader'
import { Link, useParams, useLocation } from "react-router-dom";

const Search = () => {
    const [loading, setLoading] = useState(true);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const siteUrl = process.env.REACT_APP_BACKEND_URL;

    
    const [searchResults, setSearchResults] = useState([]);
    const { query } = useParams();
    const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
        const res = await axios.get(apiBaseUrl + `search/${query}`);
        setSearchResults(res.data.result);
        console.log(res.data.result);
        setLoading(false);
    };
    if (query) {
        fetchData();

    } else {
        setSearchResults([]); // Clear results if there's no query
    }
  }, [query, location]);

  usePageSEO({
    title: "Search | Junna Solar",
    description: "Best solar company in India Junna Solar offering solar panels for home, rooftop systems."
  })   

  return (
    <>
    <Header/>

    { loading && ( <Loader /> )}

    <section className="section-content-block">
        <div className="container" key={location.key}>
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 text-center">               
                    <div className="about-us-intro">
                        <p className="blue">Search</p>
                        <p className="col-lg-offset-2 col-lg-8 col-md-12 col-sm-12 col-xs-12">
                            Search Results for "{query}"
                        </p>
                       {(searchResults.length) === 0 && (
                         <p className="col-sm-12 col-xs-12">No result found. Try with another searching word</p>
                        )}
                    </div>
                </div> 
            </div>           
            {(searchResults.length) > 0 && (
            <div className="row">     
                {searchResults.map((result, index) => (
                <div key={index} className="col-lg-12 col-md-12 col-sm-12 border-bottom">
                    <p><strong>{result?.name}</strong></p>
                    {result?.heading && (
                      <p>{result?.heading}</p>
                    )}
                    {result?.description && (
                        <p>{result?.description}</p>
                    )}
                    {result?.link_page && (
                    <Link to={`/${result?.link_page}`} className="btn btn-primary download" style={{ 'margin-left' : 0}}>Know more</Link>
                    )}
                </div>
                ))}

            </div>
            )}

        </div>
    </section>     

    <Footer/>    
    </>
  )
}

export default Search